<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xs="12" sm="6" md="5" lg="4">
          <v-card class="pa-4 text-center headline" outlined tile>
            {{ currentDay }} {{ currentDate }}
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xs="12" sm="6" md="5" lg="4" class="text-center headline">
          <v-fade-transition leave-absolute>
            <span :key="time">
              <span>{{ time }}</span>
            </span>
          </v-fade-transition>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row v-if="timerData.isTimeRunning">
        <v-spacer></v-spacer>
        <v-col cols="12" xs="12" sm="6" md="5" lg="4">
          <form-data :references.sync="formReferences" :model="timerObj" ref="hourReference"></form-data>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
          <v-col cols="12" sm="6" xs="12" md="5" lg="4" align="center">
            <template v-if="!timerData.isTimeRunning">
              <v-badge bordered color="success" icon="mdi-play" overlap>
                <v-btn  color="success" tile dark @click="startTimer('')" class="mr-2">{{$t('message.timer.start')}}</v-btn>
              </v-badge>
            </template>
            <template v-else>
              <v-badge bordered color="error" icon="mdi-stop" overlap>
                <v-btn tile color="error" dark @click="stopTimer" class="mr-2">{{$t('message.timer.stop')}}</v-btn>
              </v-badge>
            </template>
          </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import 'moment/min/locales'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      // currentDay: moment().format('dddd'),
      currentDate: moment().format('DD.MM.YYYY'),
      time: '00:00:00',
      webWorkerInstance: null,
      timerObj: {
        id: null,
        project_id: 0
      },
      listOfActivities: [],
      isInitital: true
    }
  },
  components: {
    'form-data': () => import('@/components/FormTemplate')
  },
  computed: {
    ...mapGetters(['getuserDetails', 'formType', 'getWorktypes', 'timerData', 'getActivities', 'getCurrentProjects']),
    currentDay () {
      const lang = this.$i18n.locale === 'no' ? 'nb' : 'en'
      return moment().locale(lang).format('dddd')
    },
    formReferences () {
      return {
        properties: [{
          model: 'project_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.getCurrentProjects,
          select_text: (val) => `${val.name}`,
          select_value: 'id',
          change: this.saveProject,
          label: this.$t('message.layout.projects'),
          class: 'xs12'
        }, /* {
          model: 'worktype_id',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.getWorktypes,
          is_list: false,
          click: (search) => false,
          term: '',
          change: this.saveWorkType,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.worktypes'),
          class: 'xs12'
        }, */ /* {
          model: 'task',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.common.task'),
          change: this.saveTask,
          class: 'xs12'
        },  */{
          model: 'activity_id',
          type: this.formType.AUTO_COMPLETE,
          rules: [],
          items: this.listOfActivities,
          is_list: false,
          click: (search) => false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          change: this.saveActivity,
          label: this.$t('message.layout.activities'),
          class: 'xs12'
        }, {
          model: 'comments',
          type: this.formType.TEXTAREA,
          rules: [],
          change: this.saveComments,
          label: this.$t('message.common.comments'),
          class: 'xs12'
        }],
        buttons: []
      }
    }
  },
  created () {
    this.$store.dispatch('getCurrentProjects')
    this.$store.dispatch('getWorktypes').then(() => {
      this.timerObj.worktype_id = this.getWorktypes.find(x => x.isdefault).id
    })
    this.$store.dispatch('getActivities')
  },
  watch: {
    'timerObj.project_id' (val) {
      if (val) this.listOfActivities = this.getActivities.filter(x => x.project_id === val)
      else this.listOfActivities = []
    }
  },
  mounted () {
    this.timerObj.user_id = this.getuserDetails.id
    let isRunning = window.localStorage.getItem('is_timer_running') || 'false'
    if (isRunning === 'true') this.getRunningStemp()
  },
  methods: {
    getRunningStemp () {
      this.$store.dispatch('getRunningTimer', this.getuserDetails.id)
        .then((data) => {
          if (data) {
            this.timerObj = data
            if (!this.timerObj.project_id) this.timerObj.project_id = 0
            if (data.time) {
              this.startTimer(data.time)
            }
          }
        })
    },
    startTimer (time) {
      if (!time) time = new Date()
      if (typeof (Worker) !== 'undefined') {
        if (this.webWorkerInstance === null) {
          this.webWorkerInstance = new Worker(`../../../js/timer.js?date=${time}`)
        }
        this.webWorkerInstance.onmessage = (event) => {
          this.time = event.data
        }
        this.$store.commit('setTimerValue', this.time)
        window.localStorage.setItem('is_timer_running', true)
        if (!this.timerObj.id) this.saveRecord()
      } else {
        alert('Browser is not supporting web workers!')
      }
    },
    stopTimer () {
      if (this.$refs.hourReference.$refs.validateForm.validate()) {
        this.$api.execute('put', `stamptimes/stop/${this.timerObj.id}?datetime=${moment().format('YYYY-MM-DD HH:mm:ss')}`, {})
          .then(response => {
            if (this.webWorkerInstance) this.webWorkerInstance.terminate()
            this.webWorkerInstance = null
            this.$store.commit('clearTimerValue')
            this.$eventBus.$emit('stopTimer')
            this.time = '00:00:00'
            this.timerObj = {}
            window.localStorage.setItem('is_timer_running', false)
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'success',
              text: this.$t('message.common.updatedSuccess')
            })
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveRecord () {
      this.timerObj.user_id = this.getuserDetails.id
      let model = this.$format.cloneVariable(this.timerObj)
      model.start_at = model.start_at ? model.start_at : moment().format('YYYY-MM-DDTHH:mm:ss')
      let url = model.id ? `stamptimes/update/${model.id}` : 'stamptimes/start'
      let method = model.id ? 'put' : 'post'
      let msg = model.id ? this.$t('message.common.updatedSuccess') : this.$t('message.common.addedSucess')
      this.$api.execute(method, url, model).then(response => {
        this.timerObj = response.data
        if (!this.timerObj.project_id) this.timerObj.project_id = 0
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'success',
          text: msg
        })
      })
    },
    saveProject () {
      this.saveRecord()
    },
    saveWorkType () {
      this.saveRecord()
    },
    saveActivity () {
      this.saveRecord()
    },
    saveTask () {
      this.saveRecord()
    },
    saveComments () {
      this.saveRecord()
    }
  }
}
</script>
